import { authHeader } from "../auth/authHeader";
import axios from "axios";
import { userService } from "./user.services";

// ─── Stratification Criteria ──────────────────────────────────────────────────

const getStratificationCriteria = async (params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/stratification/criteria/",
      { ...options, params },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// ─── Care / Patient Stratification ────────────────────────────────────────────

const getCareStratification = async (careId) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API +
        `/stratification/cares/${careId}/stratification/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const getPatientStratification = async (patientId) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API +
        `/stratification/patients/${patientId}/stratification/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const recalculateCareStratification = async (careId) => {
  const options = authHeader("POST");
  try {
    const response = await axios.post(
      process.env.REACT_APP_ROOT_API +
        `/stratification/cares/${careId}/recalculate/`,
      {},
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// ─── Risk ATC Groups ──────────────────────────────────────────────────────────

const getRiskAtcGroups = async (params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/stratification/risk-atc-groups/",
      { ...options, params },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const createRiskAtcGroup = async (payload) => {
  const options = authHeader("POST");
  try {
    const response = await axios.post(
      process.env.REACT_APP_ROOT_API + "/stratification/risk-atc-groups/",
      payload,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const getRiskAtcGroup = async (id) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + `/stratification/risk-atc-groups/${id}/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const deleteRiskAtcGroup = async (id) => {
  const options = authHeader("DELETE");
  try {
    const response = await axios.delete(
      process.env.REACT_APP_ROOT_API + `/stratification/risk-atc-groups/${id}/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// ─── Risk Diagnoses ───────────────────────────────────────────────────────────

const getRiskDiagnoses = async (params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/stratification/risk-diagnoses/",
      { ...options, params },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const createRiskDiagnosis = async (payload) => {
  const options = authHeader("POST");
  try {
    const response = await axios.post(
      process.env.REACT_APP_ROOT_API + "/stratification/risk-diagnoses/",
      payload,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const getRiskDiagnosis = async (id) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + `/stratification/risk-diagnoses/${id}/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const deleteRiskDiagnosis = async (id) => {
  const options = authHeader("DELETE");
  try {
    const response = await axios.delete(
      process.env.REACT_APP_ROOT_API + `/stratification/risk-diagnoses/${id}/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// ─── Risk Lab Parameters ──────────────────────────────────────────────────────

const getRiskLabParameters = async (params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/stratification/risk-lab-parameters/",
      { ...options, params },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const createRiskLabParameter = async (payload) => {
  const options = authHeader("POST");
  try {
    const response = await axios.post(
      process.env.REACT_APP_ROOT_API + "/stratification/risk-lab-parameters/",
      payload,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const getRiskLabParameter = async (id) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API +
        `/stratification/risk-lab-parameters/${id}/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const updateRiskLabParameter = async (id, payload) => {
  const options = authHeader("PATCH");
  try {
    const response = await axios.patch(
      process.env.REACT_APP_ROOT_API +
        `/stratification/risk-lab-parameters/${id}/`,
      payload,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const deleteRiskLabParameter = async (id) => {
  const options = authHeader("DELETE");
  try {
    const response = await axios.delete(
      process.env.REACT_APP_ROOT_API +
        `/stratification/risk-lab-parameters/${id}/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// ─── Keywords ─────────────────────────────────────────────────────────────────

const getKeywords = async (params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/stratification/keywords/",
      { ...options, params },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const createKeyword = async (payload) => {
  const options = authHeader("POST");
  try {
    const response = await axios.post(
      process.env.REACT_APP_ROOT_API + "/stratification/keywords/",
      payload,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const getKeyword = async (id) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + `/stratification/keywords/${id}/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const updateKeyword = async (id, payload) => {
  const options = authHeader("PUT");
  try {
    const response = await axios.put(
      process.env.REACT_APP_ROOT_API + `/stratification/keywords/${id}/`,
      payload,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const patchKeyword = async (id, payload) => {
  const options = authHeader("PATCH");
  try {
    const response = await axios.patch(
      process.env.REACT_APP_ROOT_API + `/stratification/keywords/${id}/`,
      payload,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const deleteKeyword = async (id) => {
  const options = authHeader("DELETE");
  try {
    const response = await axios.delete(
      process.env.REACT_APP_ROOT_API + `/stratification/keywords/${id}/`,
      { ...options },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// ─── Číselníky (Lookups) ──────────────────────────────────────────────────────

const searchAtcGroups = async (search = "", params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/atc-groups/",
      { ...options, params: { search, limit: 50, ...params } },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const searchDiagnoses = async (search = "", params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/diagnoses/",
      { ...options, params: { search, limit: 50, ...params } },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const searchCheckinAreas = async (search = "", params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/checkin-areas/",
      { ...options, params: { search, limit: 50, ...params } },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

const searchParameterDefinitions = async (search = "", params = {}) => {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/complement/parameter-definitions/",
      { ...options, params: { search, limit: 50, ...params } },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// ─── Error Handler ────────────────────────────────────────────────────────────

function handleError(error) {
  if (error.response && error.response.status === 401) {
    userService.logout();
    window.location.replace("/signin");
  }
  return Promise.reject(error);
}

// ─── Export ───────────────────────────────────────────────────────────────────

export const stratificationService = {
  getStratificationCriteria,
  getCareStratification,
  getPatientStratification,
  recalculateCareStratification,

  getRiskAtcGroups,
  createRiskAtcGroup,
  getRiskAtcGroup,
  deleteRiskAtcGroup,

  getRiskDiagnoses,
  createRiskDiagnosis,
  getRiskDiagnosis,
  deleteRiskDiagnosis,

  getRiskLabParameters,
  createRiskLabParameter,
  getRiskLabParameter,
  updateRiskLabParameter,
  deleteRiskLabParameter,

  getKeywords,
  createKeyword,
  getKeyword,
  updateKeyword,
  patchKeyword,
  deleteKeyword,

  searchAtcGroups,
  searchDiagnoses,
  searchCheckinAreas,
  searchParameterDefinitions,
};
